// const path = "/v2/organization/writer";
/**
 * @param {Object} param0
 * @param {import("axios").AxiosInstance} param0.repository
 */
export default function actions({ repository } = {}) {
  const responsepath = `/v2/organization/analyst/response`;
  const userpath = `/v2/organization/analyst/course`;
  return Object.freeze({
    responses: {
      download: downloadResponses,
      responsepath,
      getByCourse: getResponsesByCourse,
      getCountByCourse: getResponseCountByCourse
    },
    users: {
      download: downloadUsers,
      userpath,
      getByCourse: getUsersByCourse,
      getCountByCourse: getUserCountByCourse
    }
  });
  /**
   * @returns {Blob}
   */
  async function downloadUsers({ courseid: cid } = {}) {
    return repository
      .get(`/v2/organization/analyst/course/download/`, {
        params: {
          cid: cid
        }
      })
      .then(response => {
        console.log(response.data);
        return Promise.resolve(new Blob([response.data]));
      });
  }
  /**
   * @returns {Blob}
   */
  async function downloadResponses({ courseid: cid, dayid: did } = {}) {
    return repository
      .get(`/v2/organization/analyst/response/download/${did ? "" : "all"}`, {
        params: {
          cid: cid,
          did: did
        }
      })
      .then(response => {
        console.log(response.data);
        return Promise.resolve(new Blob([response.data]));
      });
  }
  /**
   *
   * @param {Object} param0
   * @param {String} param0.courseid
   * @param {String} param0.dayid
   * @return {Array}
   */
  async function getResponseCountByCourse({ courseid, dayid }) {
    // console.log("Getting response count");
    return repository
      .get(`/v2/organization/analyst/count`, {
        params: {
          cid: String(courseid),
          did: String(dayid),
          type: "response"
        }
      })
      .then(response => {
        return Promise.resolve(response.data.object);
      });
  }
  /**
   *
   * @param {Object} param0
   * @param {Number} param0.offset
   * @param {String} param0.courseid
   * @param {String} param0.dayid
   * @returns {Array}
   */
  async function getResponsesByCourse({
    // fields,
    offset,
    // numItems,
    courseid,
    dayid
  }) {
    return await repository
      .get(responsepath, {
        params: {
          cid: String(courseid),
          did: String(dayid),
          offset: offset
        }
      })
      .then(response => {
        return Promise.resolve(response.data.object);
      });
  }
  async function getUserCountByCourse({ courseid }) {
    return repository
      .get(`${userpath}/count`, {
        params: {
          cid: String(courseid)
        }
      })
      .then(response => {
        return Promise.resolve(response.data.object);
      });
  }
  async function getUsersByCourse({ courseid, offset }) {
    return repository
      .get(`${userpath}`, {
        params: {
          cid: String(courseid),
          offset: offset
        }
      })
      .then(response => {
        return Promise.resolve(response.data.object);
      });
  }
}
